export const DEFAULT_WORD_LENGTH = 5
export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 2800
export const REVEAL_TIME_MS = 250
export const GAME_LOST_INFO_DELAY = 2000
export const WELCOME_INFO_MODAL_MS = 350